import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { convertToPlain } from '@awread/kernel/tools';

@Component({
  standalone: true,
  selector: 'wrt-info-book',
  imports: [CommonModule],
  templateUrl: './wrt-info-book.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WrtInfoBookAtom implements OnInit {
  @Input() chapter = {
    title: '',
    content: '',
    position: '0',
    published: true,
  };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {}

  convertToPlain(content: string) {
    return convertToPlain(content);
  }
}
